import React from 'react';
import './DestinationsHero.css';

function DestinationsHero({ searchQuery, setSearchQuery }) {
  return (
    <section className="destinations-hero">
      <div 
        className="destinations-hero-background"
        style={{
          backgroundImage: `url('/assets/imgs/destination/serengeti1.jpg')`
        }}
      >
        <div className="destinations-hero-overlay"></div>
      </div>
      <div className="destinations-hero-content">
        <h1 className="destinations-hero-title">Discover Tanzania's Wonders</h1>
        <p className="destinations-hero-subtitle">
          Explore breathtaking national parks, pristine beaches, and iconic mountains
        </p>
        <div className="destinations-search">
          <input
            type="text"
            placeholder="Search destinations..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="destinations-search-input"
          />
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            className="destinations-search-icon"
          >
            <circle cx="11" cy="11" r="8"/>
            <path d="M21 21l-4.35-4.35"/>
          </svg>
        </div>
      </div>
    </section>
  );
}

export default DestinationsHero;

